<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-overlay">
    <img src="assets/images/IMG_2087_Original%20kopi%20uten%20lys%20og%20kabel.jpg" alt="NBHA Norway" class="hero-image" />
  </div>
  <div class="hero-content">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h1 class="hero-title animate-fade-in" style="color: white;">Welcome to NBHA Norway</h1>
          <p class="hero-subtitle animate-fade-in-delay">The premier barrel racing community in Norway</p>
<!--          <div class="hero-buttons mt-4 animate-fade-in-delay-2">-->
<!--            <a routerLink="/shows" class="btn btn-primary btn-lg me-3 mb-2" style="background-color: darkred!important">Upcoming Events</a>-->
<!--            <a routerLink="/user-profile" class="btn btn-primary btn-lg mb-2">Join Us Today</a>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Features Section -->
<section class="features-section py-5">
  <div class="container" style="max-width: 1400px">
    <div class="text-center mb-5">
      <h2 class="section-title">Why Choose NBHA Norway?</h2>
      <p class="section-subtitle text-muted">Join Norway's leading barrel racing community</p>
    </div>

    <div class="row g-4">
      <div class="col-lg-4 col-md-6">
        <div class="feature-card h-100">
          <div class="feature-icon bg-primary">
            <i class="fa fa-trophy bg-primary fs-2qx"></i>
          </div>
          <h3 class="feature-title">Competitive Events</h3>
          <p class="feature-text f-18">Participate in exciting barrel racing competitions throughout Norway. From beginners to professionals, we have events for all skill levels.</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-card h-100">
          <div class="feature-icon bg-primary">
            <i class="fa fa-heart fs-2qx bg-primary"></i>
          </div>
          <h3 class="feature-title">Strong Community</h3>
          <p class="feature-text">Connect with fellow riders, share experiences, and grow together in a supportive and passionate community dedicated to barrel racing.</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-card h-100">
          <div class="feature-icon bg-primary">
            <i class="fa fa-graduation-cap fs-2qx bg-primary"></i>
          </div>
          <h3 class="feature-title">Learn & Grow</h3>
          <p class="feature-text">Access resources, training opportunities, and expert guidance to improve your skills and excel in barrel racing competitions.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Image Gallery Section -->
<section class="gallery-section py-5 bg-light">
  <div class="container" style="max-width: 1400px">
    <div class="text-center mb-5">
      <h2 class="section-title">Experience the Excitement</h2>
      <p class="section-subtitle text-muted">See what makes barrel racing so thrilling</p>
    </div>

    <div class="row g-4">
      <div class="col-lg-6">
        <div class="gallery-item">
          <img src="assets/images/DSC_9347.jpg" alt="Barrel Racing" class="gallery-image" />
          <div class="gallery-overlay">
            <h4 style="color: white">Professional Competition</h4>
            <p>Watch the best riders compete at the highest level</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="gallery-item">
          <img src="assets/images/IMG_0626.jpg" alt="Training" class="gallery-image gallery-image-mirrored" />
          <div class="gallery-overlay">
            <h4 style="color: white">Training & Development</h4>
            <p>Improve your skills with expert coaching</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Highlights Section -->
<section class="highlights-section py-5">
  <div class="container" style="max-width: 1400px">
    <div class="row align-items-center g-5">
      <div class="col-lg-6">
        <div class="highlight-image-wrapper">
          <img src="assets/images/IMG_0886.jpg" alt="Riders" class="highlight-image" />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="highlight-content">
          <h2 class="highlight-title">For Riders of All Levels</h2>
          <p class="highlight-text">Whether you're just starting your barrel racing journey or you're a seasoned competitor, NBHA Norway provides the perfect platform to pursue your passion. Our events are designed to challenge and inspire riders at every stage of their development.</p>
          <ul class="highlight-list">
            <li><i class="fa fa-check-circle text-primary me-2"></i>Beginner-friendly events and training</li>
            <li><i class="fa fa-check-circle text-primary me-2"></i>Advanced competition opportunities</li>
            <li><i class="fa fa-check-circle text-primary me-2"></i>Year-round event calendar</li>
            <li><i class="fa fa-check-circle text-primary me-2"></i>Open to all horse breeds</li>
          </ul>
<!--          <a routerLink="/shows" class="btn btn-primary mt-3">View Events</a>-->
        </div>
      </div>
    </div>

    <div class="row align-items-center g-5 mt-5">
      <div class="col-lg-6 order-lg-2">
        <div class="highlight-image-wrapper">
          <img src="assets/images/PSX_20210711_230450_Original.JPG" alt="Community" class="highlight-image" />
        </div>
      </div>
      <div class="col-lg-6 order-lg-1">
        <div class="highlight-content">
          <h2 class="highlight-title">Join Our Growing Community</h2>
          <p class="highlight-text">Become part of Norway's most active barrel racing community. Connect with riders who share your passion, exchange tips and experiences, and build lasting friendships both in and out of the arena.</p>
          <ul class="highlight-list">
            <li><i class="fa fa-check-circle text-primary me-2"></i>Active member network</li>
            <li><i class="fa fa-check-circle text-primary me-2"></i>Social events and gatherings</li>
            <li><i class="fa fa-check-circle text-primary me-2"></i>Member range from kids to seniors</li>
            <li><i class="fa fa-check-circle text-primary me-2"></i>Exclusive member benefits</li>
          </ul>
<!--          <a routerLink="/user-profile" class="btn btn-primary mt-3">Become a Member</a>-->
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<!--<section class="cta-section py-5 bg-primary">-->
<!--  <div class="container text-center">-->
<!--    <div class="row justify-content-center">-->
<!--      <div class="col-lg-8">-->
<!--        <h2 class="cta-title mb-4">Ready to Get Started?</h2>-->
<!--        <p class="cta-text mb-4">Join NBHA Norway today and become part of the most exciting barrel racing community in the country. Whether you're competing or just love the sport, there's a place for you here.</p>-->
<!--        <div class="cta-buttons">-->
<!--          <a routerLink="/user-profile" class="btn btn-light btn-lg me-3 mb-2">Create Account</a>-->
<!--          <a routerLink="/shows" class="btn btn-secondary btn-lg mb-2">Browse Events</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->
